import moment from 'moment'
import { LogOccurence } from "../../types";
import { ACTIONS_NAME, INPUTS_NAME, subTopicSupport, typesOcorrenceStatus, typeStatusOccurence, typeSubjectOccorence } from "../../constants";
import { Button, DatePicker, NoData, Select, Spinner } from '@rio-cloud/rio-uikit';

interface Props {
    data?: LogOccurence[]
    startDate: string;
    endDate: string;
    user: string;
    handleStartDate: (date: string) => void;
    handleEndDate: (date: string) => void;
    status?: string[];
    handleStatus: (status?: string[]) => void;
    handleUser: (user: string) => void;
    handleSubmit: () => void;
    isLoading: boolean;
};

export default function SupportHistoryPage({
    data,
    status,
    handleStatus,
    user,
    handleUser,
    endDate,
    handleEndDate,
    handleStartDate,
    startDate,
    handleSubmit,
    isLoading
}: Readonly<Props>) {

    const renderValue = (value: string, fieldChanged: string) => {
        if (fieldChanged === 'status') {
            return typesOcorrenceStatus[value as keyof typeof typesOcorrenceStatus];
        }

        if (fieldChanged === 'subject') {
            return typeSubjectOccorence[value as keyof typeof typeSubjectOccorence];
        }

        if (fieldChanged === 'subtopic') {
            return subTopicSupport[value as keyof typeof subTopicSupport];
        }

        return value;
    }

    return (
        <div className="mx-auto px-4 pb-10">
            <div className="mb-8">
                <form className="flex justify-start items-center flex-wrap gap-6">
                    <div className='form-group flex-1'>
                        <label className='text-size-12 text-color-darker'>
                            Etapa
                        </label>
                        <Select
                            id="type"
                            value={status}
                            onChange={(item) => handleStatus(item?.id ? [item?.id as string] : undefined)}
                            options={typeStatusOccurence}
                            useClear
                            placeholder="Selecione"
                        />
                    </div>
                    <div className='form-group flex-1'>
                        <label className='text-size-12 text-color-darker'>
                            Usuário
                        </label>
                        <input
                            type='text'
                            className='form-control'
                            value={user}
                            placeholder='Usuário'
                            onChange={(e) => handleUser(e.target.value)}
                        />
                    </div>
                    <div className='flex-1-1'>
                        <label htmlFor='start' className='text-size-12 text-color-darker'>
                            Data de atualização
                        </label>
                        <div className='display-flex'>
                            <div className='form-group  w-full'>
                                <DatePicker
                                    id='start'
                                    timeFormat={false}
                                    dateFormat='DD/MM/YYYY'
                                    value={startDate ? moment(startDate).format('DD/MM/YYYY') : undefined}
                                    onChange={(v) => handleStartDate(moment(v).format('YYYY-MM-DD'))}
                                    className="margin-0"
                                />
                            </div>
                            <p className="mt-3">Até</p>
                            <div className='form-group  w-full'>

                                <DatePicker
                                    id='end'
                                    timeFormat={false}
                                    dateFormat='DD/MM/YYYY'
                                    value={endDate ? moment(endDate).format('DD/MM/YYYY') : undefined}
                                    onChange={(v) => handleEndDate(moment(v).format('YYYY-MM-DD'))}
                                    className="margin-0"
                                />
                            </div>
                        </div>
                    </div>
                    <Button className="btn btn-primary mt-4" onClick={handleSubmit}>Aplicar filtro</Button>
                </form>
            </div>

            {isLoading ? (
                <div className='padding-20 display-flex align-item-center justify-content-center'>
                    <Spinner isDoubleSized />
                </div>
            ) : null}

            {!data?.length && !isLoading && (
                <NoData
                    text="Nenhum log encontrado"
                    className="text-size-16 border padding-20"
                />
            )}

            {data?.length && !isLoading ? (
                <div className="relative">
                    <div className="absolute left-10 top-0 bottom-0 w-px border-l-2 border-dashed border-gray-200 dark:border-neutral-700 pointer-events-none -z-0" />

                    <div className="space-y-8">
                        {data?.map((item) => (
                            <div key={item.id} className="relative flex items-start">
                                <div className="w-16 flex-shrink-0 flex justify-start z-10">
                                    <div className="flex items-center justify-center w-10 h-10 bg-slate-100 dark:bg-neutral-700 rounded-full border border-gray-200 dark:border-neutral-600 shadow-sm">
                                        <span className="rioglyph rioglyph-ok text-slate-700 dark:text-neutral-300" />
                                    </div>
                                </div>

                                <div className="flex-1">
                                    <div className="bg-white dark:bg-neutral-800 rounded-xl border border-gray-200 dark:border-neutral-700 p-4 sm:p-6">
                                        <div className="flex flex-col sm:flex-row sm:space-x-6">
                                            <div className="w-full">
                                                <div className="flex flex-row items-start justify-between sm:w-7/12">
                                                    <div className="flex flex-row items-center">
                                                        <div className="h-20 bg-slate-200 dark:bg-neutral-600" style={{ width: 0 }}></div>
                                                        <div className="flex flex-col">
                                                            <span className="font-semibold text-gray-600 dark:text-neutral-400 ">Usuário:</span>
                                                            <span className="">{item.user || '-'}</span>
                                                        </div>
                                                    </div>

                                                    <div className="flex flex-row items-center gap-20">
                                                        <div className="h-20 bg-slate-200 dark:bg-neutral-600" style={{ width: 1 }}></div>
                                                        <div className="flex flex-col">
                                                            <span className="font-semibold text-gray-600 dark:text-neutral-400">Data/Hora:</span>
                                                            <span className="font-medium ">{item.createdAt ? moment(item.createdAt).format("DD/MM/YYYY HH:mm") : '-'}</span>
                                                        </div>
                                                    </div>

                                                    <div className="flex flex-row items-center gap-20">
                                                        <div className="h-20 bg-slate-200 dark:bg-neutral-600" style={{ width: 1 }}></div>
                                                        <div className="flex flex-col">
                                                            <span className="font-semibold text-gray-600 dark:text-neutral-400">Etapa:</span>
                                                            <span className="font-medium ">{typesOcorrenceStatus[item.status as keyof typeof typesOcorrenceStatus] || '-'}</span>
                                                        </div>
                                                    </div>

                                                    <div className="flex flex-row items-center gap-20">
                                                        <div className="h-20 bg-slate-200 dark:bg-neutral-600" style={{ width: 1 }}></div>
                                                        <div className="flex flex-col">
                                                            <span className="font-semibold text-gray-600 dark:text-neutral-400">{ACTIONS_NAME[item.action as keyof typeof ACTIONS_NAME]}:</span>
                                                            <span className="font-medium ">{INPUTS_NAME[item.fieldChanged as keyof typeof INPUTS_NAME] || item.fieldChanged || '-'}</span>
                                                        </div>
                                                    </div>

                                                </div>


                                                {item.action === 'DELETE' ? null : (
                                                    <div className="display-flex flex-row margin-top-10">
                                                        {item.old ? (
                                                            <div className="width-50pct">
                                                                <div className="font-semibold text-gray-600 dark:text-neutral-400">Valor anterior:</div>
                                                                <div className="mt-2 bg-gray-50 dark:bg-neutral-900 border border-gray-100 dark:border-neutral-700 rounded-md p-3 text-gray-600 dark:text-neutral-400">
                                                                    {renderValue(item.old, item.fieldChanged)}
                                                                </div>
                                                            </div>
                                                        ) : null}

                                                        {item.new && item.old ? (
                                                            <div className="w-1 h-200 bg-slate-200 dark:bg-neutral-600"></div>
                                                        ) : null}

                                                        {item.new ? (
                                                            <div className="width-50pct">
                                                                <div className="font-semibold text-gray-600 dark:text-neutral-400">Novo valor:</div>
                                                                <div className="mt-2 bg-gray-50 dark:bg-neutral-900 border border-gray-100 dark:border-neutral-700 rounded-md p-3 text-gray-600 dark:text-neutral-400">
                                                                    {renderValue(item.new, item.fieldChanged)}
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                )}
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div >
            ) : null}
        </div >
    );
}